require("./later");
module.exports = later;


//////////////////
// WEBPACK FOOTER
// ./~/later/index-browserify.js
// module id = 404
// module chunks = 0